<template>
  <PlaceholderPantalla
    titulo="Cortes de Caja"
    subtitulo="Cierre y conciliación de ventas del turno/día"
    descripcion="Realiza cortes de caja parciales (por turno) o totales (cierre del día) con conciliación de efectivo, tarjetas y otros métodos de pago. Compara las ventas registradas contra el efectivo en caja, identifica diferencias, genera reportes de cierre, y envía información al módulo de Finanzas."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Corte de caja por turno o diario',
  'Resumen de ventas totales del período',
  'Desglose por método de pago (Efectivo, Tarjeta, Transfer, etc.)',
  'Conteo de efectivo en caja',
  'Conciliación: ventas vs efectivo contado',
  'Identificación de diferencias (sobrantes o faltantes)',
  'Detalle de tickets/ventas del período',
  'Cancelaciones y descuentos aplicados',
  'Total de propinas recibidas',
  'Retiros de efectivo realizados',
  'Fondos de inicio de caja',
  'Cálculo de efectivo a depositar',
  'Generar ingreso en Finanzas por deposito',
  'Imprimir reporte de corte de caja',
  'Historial de cortes anteriores',
  'Exportar corte a PDF/Excel',
  'Autorización de diferencias',
  'Firma digital del responsable'
]

const datosManejados = [
  'Fecha y hora del corte',
  'Tipo de corte (Turno, Diario)',
  'Cajero responsable',
  'Hora de inicio',
  'Hora de cierre',
  'Fondo inicial de caja',
  'Total de ventas en efectivo',
  'Total de ventas con tarjeta',
  'Total de otros métodos de pago',
  'Total de ventas general',
  'Efectivo contado físicamente',
  'Diferencia (+ o -)',
  'Retiros de efectivo',
  'Propinas totales',
  'Número de tickets vendidos',
  'Ticket promedio',
  'Cancelaciones del período',
  'Descuentos otorgados',
  'Efectivo a depositar',
  'Observaciones y notas'
]
</script>
